var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconPushPinSimpleSlash = function SvgIconPushPinSimpleSlash(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.661 4.75H9.572a1 1 0 1 1 0-2H18a1 1 0 1 1 0 2h-.308l1.462 8.286a1 1 0 1 1-1.97.347z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M5.24 3.077a1 1 0 1 0-1.48 1.346l2.183 2.4L4.41 15.5H3.75a1 1 0 0 0 0 2H11v5a1 1 0 1 0 2 0v-5h2.649l3.111 3.423a1 1 0 1 0 1.48-1.346zM6.442 15.5l1.201-6.806L13.83 15.5z",
    clipRule: "evenodd"
  }))));
};
export default SvgIconPushPinSimpleSlash;